import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import InfoIcon from '@/images/Info.svg';
import theme from '@/theme';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { Popover, Typography } from '@mui/material';
import { useState } from 'react';

const TranslatingTipsHover = styled.div`
    height: 4rem;
    width: 250px;
    display: flex;
    padding: 0 12px;
    gap: 8px;
    align-items: center;
    justify-content: center;
    background-color: #ddf1ff;
    border-radius: 8px;
    margin-top: 8px;
    white-space: nowrap;

    &:hover,
    & *:hover {
        cursor: default;
    }
`;

const TooltipContent = styled.div`
    padding: 4px;
    line-height: 170%;
    font-size: 14px;

    p {
        font-weight: 700;
    }

    ul {
        padding-inline-start: 8px;
        list-style: inside;
    }

    ul:first-of-type {
        margin-bottom: 10px;
    }

    ul:nth-of-type(2) {
        display: flex;
    }
`;
const styles = {
    popoverPaper: {
        width: 500,
        padding: '1rem',
        borderRadius: '8px',
        backgroundColor: theme.colors.secondary[900],
        color: 'white',
    },
};

export const TranslatingVideosTips = () => {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    return (
        <>
            <TranslatingTipsHover
                onMouseEnter={e => {
                    setAnchorEl(e.currentTarget);
                }}
                onMouseLeave={() => {
                    setAnchorEl(null);
                }}
                onClick={e => {
                    e.stopPropagation();
                }}>
                <MaskedIcon src={InfoIcon} size="18px" color={theme.colors.links.main} />
                <Typography variant="h5" fontWeight={600} color={theme.colors.secondary[900]}>
                    Guidelines for translating videos
                </Typography>
            </TranslatingTipsHover>
            <Popover
                sx={{ pointerEvents: 'none' }}
                PaperProps={{ sx: styles.popoverPaper }}
                open={!!anchorEl}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: -20,
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}>
                <TooltipContent>
                    <p>Footage tips:</p>
                    <ul>
                        <li>Only one person should be in the frame of the video</li>
                        <li>Ensure the speaker is front-facing with their face visible at all times</li>
                        <li>Minimize background noise and music to maintain clear audio.</li>
                        <li>Video duration: 10 seconds to 5 minutes</li>
                        <li>File size: up to 2GB</li>
                    </ul>

                    <p>Supported languages:</p>
                    <ul>
                        <li />
                        <span>
                            Arabic, Bulgarian, Chinese, Croatian, Czech, Danish, Dutch, English, Filipino, Finnish, French, German, Greek,
                            Hindi, Indonesian, Italian, Japanese, Korean, Malay, Polish, Portuguese, Romanian, Russian, Slovak, Spanish,
                            Swedish, Tamil, Turkish, Ukrainian
                        </span>
                    </ul>
                </TooltipContent>
            </Popover>
        </>
    );
};
